import { createReducer, on } from '@ngrx/store';
import { FilterItem } from '@fc-vehicles/components/shared/vehicle-filter/vehicles-filter.component';
import * as LocationFiltersActions from '../actions/location-filters.actions';
import { changeSortByListOrder } from '@fc-shared/utils/change-sort-by-list-order';
import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

export const locationFiltersFeatureKey = 'locationFilters';

export interface State {
  locationsSearchText: string;
  selectedFilters: FilterItem[];
  locationSortBy: SortBy;
  locationsSortList: SortBy[];
}

export const initialState: State = {
  selectedFilters: [],
  locationsSearchText: '',
  locationSortBy: {
    name: 'By name',
    value: 'name',
    order: false,
  },
  locationsSortList: [
    {
      name: 'By name',
      value: 'name',
      order: false,
    },
    {
      name: 'By area',
      value: 'area',
      order: null,
    },
    {
      name: 'By last activity',
      value: 'lastActivity',
      order: null,
    },
  ],
};

const isSameFilterItem = (left: FilterItem, right: FilterItem): boolean =>
  left.id === right.id && left.type === right.type;

export const reducer = createReducer(
  initialState,

  on(LocationFiltersActions.resetDefaultLocationFilters, (state) => ({
    ...state,
    selectedFilters: [] as FilterItem[],
    locationsSearchText: '',
    locationSortBy: initialState.locationSortBy,
    locationsSortList: initialState.locationsSortList,
  })),

  on(LocationFiltersActions.setLocationFilter, (state, action) => ({
    ...state,
    selectedFilters: state.selectedFilters.some((filter) =>
      isSameFilterItem(filter, action.filterItem),
    )
      ? state.selectedFilters.filter(
          (filter) => !isSameFilterItem(filter, action.filterItem),
        )
      : [...state.selectedFilters, action.filterItem],
  })),

  on(LocationFiltersActions.setManyLocationFilters, (state, action) => ({
    ...state,
    selectedFilters: action.filters,
  })),

  on(LocationFiltersActions.setSearchLocationText, (state, action) => ({
    ...state,
    locationsSearchText: action.searchText,
  })),
  on(LocationFiltersActions.setLocationSortBy, (state, action) => ({
    ...state,
    locationSortBy: {
      ...action.sortBy,
      order: action.sortBy === null ? true : !action.sortBy.order,
    },
    locationsSortList: changeSortByListOrder(
      state.locationsSortList,
      action.sortBy,
    ),
  })),
);

export const getSelectedFilters = (state: State) => state.selectedFilters;
export const getLocationsSearchText = (state: State) =>
  state.locationsSearchText;
export const getLocationSortBy = (state: State) => state.locationSortBy;
export const getLocationSortByList = (state: State) => state.locationsSortList;
